import { z } from "zod";
import { SequenceObjectiveSchema } from "./simulations-sequence.js";

// Enums e schemas-folha do domínio de simulação, extraídos de `simulations.ts` para que
// o módulo do LOTE (`simulations-batch.ts`) possa consumi-los sem ciclo com o arquivo que o
// re-exporta. Mesmo padrão de `assistant-catalog-types.ts`.
// O ciclo não era teórico: `ConfidenceLevelSchema` chegava `undefined` em tempo de execução e
// derrubava a coleta de metade da suíte do front.

// Objetivos do lote PARAMS. Este enum NÃO ganhou os objetivos de sequência —
// requests de lote automático continuam aceitando só os 3 abaixo. A união vive em
// AnySimulationObjectiveSchema (leitura), e o guard kind×objective mora no service.
export const SimulationObjectiveSchema = z.enum([
  "OEE_IMPROVEMENT",
  "TARGET_QUANTITY",
  "TIME_TO_QUANTITY",
  // "a OP cabe no prazo?". Quantidade e janela vêm da OP; só existe com linha base.
  "OP_ON_TIME",
]);
export type SimulationObjective = z.infer<typeof SimulationObjectiveSchema>;

// Natureza do lote (espelha o enum Prisma SimulationBatchKind).
export const SimulationBatchKindSchema = z.enum(["PARAMS", "SEQUENCE"]);
export type SimulationBatchKind = z.infer<typeof SimulationBatchKindSchema>;

// LEITURA do batch: a coluna `objective` é única no banco, logo o wire de leitura
// aceita os dois conjuntos. Qual deles é válido depende do `kind` (discriminante do mesmo shape).
export const AnySimulationObjectiveSchema = z.union([
  SimulationObjectiveSchema,
  SequenceObjectiveSchema,
]);
export type AnySimulationObjective = z.infer<typeof AnySimulationObjectiveSchema>;

export const CandidateCountSchema = z.union([
  z.literal(4),
  z.literal(6),
  z.literal(8),
  z.literal(10),
]);

export const SimulationBatchStatusSchema = z.enum([
  "QUEUED",
  "RUNNING",
  "COMPLETED",
  "NO_GAIN",
  "PARTIAL",
  "FAILED",
  "CANCELLED",
]);
export type SimulationBatchStatus = z.infer<typeof SimulationBatchStatusSchema>;

export const ConfidenceLevelSchema = z.enum(["HIGH", "MEDIUM", "LOW", "INSUFFICIENT"]);
